import AsyncStorage from '@react-native-async-storage/async-storage';

export const enum LocalStorageType {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER_CONTEXT = 'USER_CONTEXT',
  DASHBOARD_ACTIVE_ID = 'DASHBOARD_ACTIVE_ID',
  GO_TO_REGISTER_LEADS = 'GO_TO_REGISTER_LEADS',
}

export const storeLocalData = async (key: string, value: string) => {
  try {
    await AsyncStorage.setItem(key, value);
  } catch (e) {
    // saving error
  }
};

//@ts-ignore
export const getLocalData = async (key: string, callback?: Function) => {
  try {
    const value = await AsyncStorage.getItem(key);
    if (value !== null) {
      //callback && callback(value)
      return value;
    }
  } catch (e) {
    // error reading value
    return null;
  }
};

export const getLocalStorageSync = (key: LocalStorageType) => {
  if (key === LocalStorageType.ACCESS_TOKEN) {
    return localStorage.getItem(key);
  }
  //@ts-ignore
  return JSON.parse(localStorage.getItem(key));
};

export const removeLocalValue = async (key: string) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (e) {
    // remove error
  }
};
